<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                SEPA bestätigen
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="p-8">
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                SEPA Bestätigen
                            </h3>
                        </div>
                        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="col-span-6">
                                <label for="name" class="block text-sm font-medium text-gray-700">
                                    Name
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="first_name" id="name" v-model="form.name" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.name" />
                                </div>
                            </div>
                            <div class="col-span-6">
                                <label for="iban" class="block text-sm font-medium text-gray-700">
                                    IBAN
                                </label>
                                <div class="mt-1">
                                    <input type="text" id="iban" v-model="form.iban" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.iban" />
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label for="kdnr" class="block text-sm font-medium text-gray-700">
                                    Kundennummer
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="first_name" id="kdnr" v-model="form.kdnr" @change="() => {if(!reference) form.reference = form.kdnr+'-01'}" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.kdnr" />
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label for="reference" class="block text-sm font-medium text-gray-700">
                                    Mandatsreferenz
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="first_name" id="reference" v-model="form.reference" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.reference" />
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label for="date" class="block text-sm font-medium text-gray-700">
                                    Datum
                                </label>
                                <div class="mt-1">
                                    <input type="date" name="first_name" id="date" v-model="form.date" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pt-5 pr-8 pb-8">
                        <div class="flex justify-end">
                            <inertia-link :href="route('sepa.index')" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Abbrechen
                            </inertia-link>
                            <button @click="createSEPA" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                SEPA-Mandat bestätigen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jet-notification :show="form.recentlySuccessful">
            <p class="text-sm font-medium text-gray-900">
                Erfolgreich gespeichert!
            </p>
            <p class="mt-1 text-sm text-gray-500">
                SEPA-Mandat hinterlegt!
            </p>
        </jet-notification>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import InputError from "@/Jetstream/InputError";
import JetInputError from "@/Jetstream/InputError";
import JetNotification from "@/Jetstream/Notification";
import IBAN from 'iban';

export default {
    name: "Create",
    components: {JetInputError, AppLayout, JetNotification},
    props: [
        'sepa',
        'reference',
        'name',
        'iban',
        'kdnr'
    ],
    data () {
        return {
            form: this.$inertia.form({
                'name': this.name,
                'iban': this.iban,
                'reference': this.reference,
                'date': new Date().toISOString().split('T')[0],
                'kdnr': this.kdnr
            })
        }
    },
    methods: {
        createSEPA() {
            this.form.iban = this.form.iban.replace(/\s+/g, '');
            this.form.reference = this.form.reference.replace(/\s+/g, '');
            if (!IBAN.isValid(this.form.iban)) {
            alert('Die eingegebene IBAN ist ungültig.');
                return;
            }
            this.form.post(route('sepa.store', {sepa: this.sepa}),
                {
                    onSuccess: () => {
                        this.form.reset()
                    }
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
